<template>
  <!-- 达人概览 -->
  <div class="outlineContainer">
    <div class="part" v-if="pjList.length">
            <div class="title1">达人排竞信息</div>
            <div class="tips"><i class="vxe-icon-warning-circle"></i>该达人目前已排期确定参与推广的游戏或游戏类型如下，若您有合作意向且营销标的与此类似，请谨慎考虑，以免撞档。</div>
            <vxe-table :data="pjList" :column-config="{ resizable: true }" :border="false" :show-header-overflow="true" :show-overflow="true" :show-footer="false" :align="'center'">
                <vxe-column field="" title="排竞日期">
                  <template #default="{ row }">
                    <span>{{ row.start_time }} 至 {{ row.end_time }}</span><span style="color:#FF6F28"> (还有{{ row?.end_time ? getDaysRemaining(row?.end_time) : '-' }}天排竞结束)</span>
                  </template>
                </vxe-column>
                <vxe-column field="competitive_product" title="排竞游戏或类型"></vxe-column>
            </vxe-table>
        </div>
    <div v-if="supplierList.length" v-loading="loading" class="part" >
      <div class="fx-between">
        <span class="title1">供应商信息</span>
        <el-button type="text" @click="() => isSupplierListExpand = !isSupplierListExpand">
            <span v-if="isSupplierListExpand">收起<i class="el-icon-arrow-down"></i></span>
            <span v-else>展开<i class="el-icon-arrow-up"></i></span>
        </el-button>
      </div>
      <vxe-grid v-show="isSupplierListExpand" v-bind="supplierGridOptions" :data="supplierList" :row-class-name="rowClassName">
          <template #suppliers_name="{row}">
              <div>{{ row.suppliers_name }}</div>
              <div v-if="row.is_black == 1" style="color: #1D2129;">（该供应商已被拉黑）</div>
          </template>
      </vxe-grid >
    </div>
    <div v-loading="loading" class="part1 clear">
      <div class="left">
        <span class="title1"
          >重点数据
          <!-- <span class="subTitle">近30天数据表现概览</span> -->
        </span>
        <div class="center clear">
          <div class="centerItem">
            <span
              >{{
                ksIndex?.businessPowerModel?.bplayMedian
                  ? fmt(ksIndex?.businessPowerModel?.bplayMedian / 10000, {
                      micrometer: true,
                    }) || "-"
                  : "-"
              }}w</span
            >
            <p>
              聚星作品播放量中位数
              <el-tooltip
                placement="top"
                content="达人近90天已结算聚星作品中，处于中位数水平的履约期间自然流量播放量"
              >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
              </el-tooltip>
            </p>
          </div>
          <div class="centerItem">
            <span
              >{{
                darenInfo?.photoExpectPlay
                  ? fmt(darenInfo?.photoExpectPlay / 10000, {
                      micrometer: true,
                    }) || "-"
                  : "-"
              }}w</span
            >
            <p>
              预期播放量
              <el-tooltip
                placement="top"
                content="根据达人历史作品信息，预估的商单作品履约期间自然流量播放量，仅供参考"
              >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
              </el-tooltip>
            </p>
          </div>
          <div class="centerItem">
            <span
              >{{
                ksIndex?.costEffectiveModel?.videoCpmExpectancy|| "-"
              }}</span
            >
            <p>
              预期CPM
              <el-tooltip
                placement="top"
                content="根据达人报价和预估播放量计算得出，仅供参考"
              >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
              </el-tooltip>
            </p>
          </div>
        </div>
        <!-- <span class="title1">商业数据</span> -->
        <div class="center clear">
          <div class="centerItem">
            <span
              >{{
               darenInfo?.videoBusinessReport?.acceptOrderRateData? fmt(darenInfo?.videoBusinessReport?.acceptOrderRateData?.["90"]*100) : "-"
              }}%</span
            >
            <p>近90天接单率</p>
          </div>
          <div class="centerItem">
            <span
              >{{
                darenInfo?.videoWeeklyAvgWorksCnt|| "-"
              }}</span
            >
            <p>周均发布作品数</p>
          </div>
          <div class="centerItem">
            <span
              >{{
                ksIndex?.costEffectiveModel?.videoCpe|| "-"
              }}</span
            >
            <p>
              CPE
              <el-tooltip
                placement="top"
                content="根据达人报价、近90天发布视频互动数计算得出"
              >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
              </el-tooltip>
              <!-- <i>{{darenInfo.videoBusinessReport.completeOrderRateRank?darenInfo.videoBusinessReport.completeOrderRateRank:"-"}}</i> -->
            </p>
          </div>
          <!-- <div class="centerItem">
                        <span>{{darenInfo.videoBusinessReport.completeOrderCnt?darenInfo.videoBusinessReport.completeOrderCnt:"-"}}</span>
                        <p>订单完成数</p>
                    </div> -->
        </div>
        <span class="title1">历史合作行业</span>
        <div class="tag clear">
          <span
            v-for="(item, index) in darenInfo.videoBusinessReport
              .advertiserFirstIndustries"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="right">
        <span class="title1">粉丝画像</span>
        <div class="rightItem">
          <div class="title2">粉丝特征</div>
          <span
            class="tag"
            v-for="(item, index) in darenInfo.viewerFeatureTag"
            :key="index"
            >{{ item }}</span
          >
        </div>
        <div class="rightItem">
          <div class="title2">粉丝设备</div>
          <span
            class="tag"
            v-for="(item, index) in darenInfo.viewerDeviceTag"
            :key="index"
            >{{ item }}</span
          >
        </div>
        <div class="rightItem">
          <div class="title2">粉丝分布</div>
          <span
            class="tag"
            v-for="(item, index) in darenInfo.viewerAreaTag"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
    <div v-loading="loading" class="part">
      <span class="title1">达人指数</span>
      <div class="flex_box">
        <div>
          <div class="drIndex">
            <span class="bignum">{{ videoStarIndex?.powerValue || "-" }}</span>
            <span>同类型达人排名<strong>{{videoStarIndex?.powerRank || "-"}}</strong>，超过<strong>{{fmt(videoStarIndex?.powerPercent  * 100, {micrometer: true,})|| "-"}}%</strong>的达人</span>
          </div>
          <div class="radar_box">
            <Radar :info="starPicRadar" ref="part1Chart"></Radar>
          </div>
        </div>
        <div>
          <el-tabs v-model="activeName" class="subTitle">
            <el-tab-pane label="传播力指数" name="传播力指数"></el-tab-pane>
            <el-tab-pane label="发展力指数" name="发展力指数"></el-tab-pane>
            <el-tab-pane label="号召力指数" name="号召力指数"></el-tab-pane>
            <el-tab-pane label="商业力指数" name="商业力指数"></el-tab-pane>
            <el-tab-pane label="性价比指数" name="性价比指数"></el-tab-pane>
          </el-tabs>
          <div class="drIndexRight">
            <div class="drFirstRow">
              <span
                class="rankNum">{{rankObj.rankNum}}</span
              ><span>同类型达人排名<strong>{{ rankObj.rankNo }}</strong>，超过<strong>{{rankObj.rankPercent}}%</strong>的达人</span>
            </div>
            <div class="indexSource">
              <span style="font-weight: 600">指数来源：</span>依据达人近30天数据表现得出
            </div>
            <div class="flex_box">
              <template v-if="activeName=='传播力指数'">
                <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.spreadingPowerModel?.pphotoCnt ||'-'}}
                </div>
                <div>
                  个人作品数
                  <el-tooltip
                    placement="top"
                    content="达人近期已发布至少7天的个人作品视频"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{  ksIndex?.spreadingPowerModel?.pcompletePlayRate ? fmt(ksIndex?.spreadingPowerModel?.pcompletePlayRate*100,{micrometer: true,}) : '-' ||'-'}}%
                </div>
                <div>
                  个人作品完播率
                  <el-tooltip
                    placement="top"
                    content="达人近期发布的视频中，被完整播放的概率，仅统计7日自然流量的数据"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.spreadingPowerModel?.pplayMedian || '-'}}
                </div>
                <div>
                  个人作品播放量中位数
                  <el-tooltip
                    placement="top"
                    content="达人近期发布的视频中，处于中位数水平的自然流量7日播放量"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.spreadingPowerModel?.pinteractionRate? fmt(ksIndex?.spreadingPowerModel?.pinteractionRate*100,{micrometer: true,}) : '-' ||'-'}}%
                </div>
                <div>
                  个人作品互动率
                  <el-tooltip
                    placement="top"
                    content="达人近期发布的作品中，被点赞、评论、分享的概率，仅统计7日自然流量的数据"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              </template>
              <template v-if="activeName=='发展力指数'">
                <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.developPowerModel?.fansUpRate ? fmt(ksIndex?.developPowerModel?.fansUpRate*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  粉丝增长率
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.developPowerModel?.fansIncreaseCnt ? fmt(ksIndex?.developPowerModel?.fansIncreaseCnt/10000,{micrometer: true,}) : '-'}}w
                </div>
                <div>
                  粉丝增长量
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.developPowerModel?.videoActiveFansRatioIncreaseNum ? fmt(ksIndex?.developPowerModel?.videoActiveFansRatioIncreaseNum*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  活跃粉丝占比增长
                  <el-tooltip
                    placement="top"
                    content="观看达人短视频粉丝占比增长值，数据更新到20230910"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              </template>
              <template v-if="activeName=='号召力指数'">
                <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.appealPowerModel?.videoHighQualityFansCnt ? fmt(ksIndex?.appealPowerModel?.videoHighQualityFansCnt/10000,{micrometer: true,}) : '-'}}w
                </div>
                <div>
                  高质量粉丝数
                  <el-tooltip
                    placement="top"
                    content="与达人有内容互动或者完整观看视频的粉丝数，数据更新到20230910"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.appealPowerModel?.videoFansInteractionRate ? fmt(ksIndex?.appealPowerModel?.videoFansInteractionRate*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  粉丝互动率
                  <el-tooltip
                    placement="top"
                    content="与达人有互动行为的粉丝占比，数据更新到20230910"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.appealPowerModel?.videoActiveFansRatio ? fmt(ksIndex?.appealPowerModel?.videoActiveFansRatio*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  活跃粉丝占比
                  <el-tooltip
                    placement="top"
                    content="观看达人短视频粉丝占比，数据更新到20230910"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              </template>
              <template v-if="activeName=='商业力指数'">
                <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.businessPowerModel?.videoCooperationIndex || '-'}}
                </div>
                <div>
                  合作指数
                  <el-tooltip
                    placement="top"
                    content="综合建联率、接单率、完单率，综合计算得出"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.businessPowerModel?.completeOrderCnt ? fmt(ksIndex?.businessPowerModel?.completeOrderCnt/10000,{micrometer: true,}) : '-'}}w
                </div>
                <div>
                  完单数
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.businessPowerModel?.bplayMedian ? fmt(ksIndex?.businessPowerModel?.bplayMedian/10000,{micrometer: true,}) : '-'}}w
                </div>
                <div>
                  聚星作品播放量中位数
                  <el-tooltip
                    placement="top"
                    content="达人近期已结算的视频中，处于中位数水平的履约期间自然流量播放量"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.businessPowerModel?.bcompletePlayRate ? fmt(ksIndex?.businessPowerModel?.bcompletePlayRate*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  聚星作品完播率
                  <el-tooltip
                    placement="top"
                    content="达人近期已结算的视频中，被完整播放的概率，仅统计履约期间自然流量"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.businessPowerModel?.binteractionRate ? fmt(ksIndex?.businessPowerModel?.binteractionRate*100,{micrometer: true,}) : '-'}}%
                </div>
                <div>
                  聚星作品互动率
                  <el-tooltip
                    placement="top"
                    content="达人近期已结算的视频中，被点赞、评论、分享的概率，仅统计履约期间自然流量"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              </template>
              <template v-if="activeName=='性价比指数'">
                <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.costEffectiveModel?.videoCpmExpectancy || '-'}}
                </div>
                <div>
                  预期CPM
                  <el-tooltip
                    placement="top"
                    content="根据达人报价和预估播放量计算得出，仅供参考"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.costEffectiveModel?.videoCpc || '-'}}
                </div>
                <div>
                  CPC
                  <el-tooltip
                    placement="top"
                    content="单次点击的消耗"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              <div class="indexBlock">
                <div class="indexNum">
                  {{ ksIndex?.costEffectiveModel?.videoCpe || '-'}}
                </div>
                <div>
                  CPE
                  <el-tooltip
                    placement="top"
                    content="CPE"
                  >
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
                </div>
              </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tools from "../../../components/tools/tools.js";
import Radar from "../../../components/newEchart/Radar.vue";
export default {
  name: "Outline",
  // props: ["darenID", "fatherDarenInfo"],
  props:{
     'darenID':{
        type: String,
        default: ''
     },
     'fatherDarenInfo':{
        type: Object,
        default:()=>({})
     },
     'supplierList':{
        type: Array,
        default:()=>([])
     }
  },
  data() {
    return {
      pjList:[],
      darenInfo: {
        videoBusinessReport: {},
        // videoBusinessReport: [],
        fansFeatureTag: [],
        fansDeviceTag: [],
        fansAreaTag: [],
      },
      ksIndex: {
        costEffectiveModel: {},
        businessPowerModel: {},
      },
      videoStarIndex:{},
      starPicRadar: {},
      activeName:"传播力指数",
      rankObj:{
        rankNum:0,
        rankNo:0,
        rankPercent:0,
      },
      loading: false,
      supplierGridOptions: {
          border: 'inner',
          maxHeight: '380',
          columns: [
              { field: 'product_name', title: '产品类型' },
              { field: 'account_type', title: '账号类型' },
              { field: 'suppliers_name', title: '供应商', slots: { default:'suppliers_name' } },
              { field: 'devidedrate', title: '媒体侧自然返点%' },
          ],
      },
      isSupplierListExpand: true
    };
  },
  computed: {},
  watch:{
    activeName:{
      handler(val){
        let {spreadingPowerModel, costEffectiveModel, businessPowerModel, appealPowerModel, developPowerModel} = this.ksIndex
        if(val=="传播力指数"){
          this.rankObj.rankNum = spreadingPowerModel?.videoSpreadingIndex?.powerValue || "-"
          this.rankObj.rankNo = spreadingPowerModel?.videoSpreadingIndex?.powerRank || "-"
          this.rankObj.rankPercent =spreadingPowerModel?.videoSpreadingIndex?.powerPercent? this.fmt(spreadingPowerModel?.videoSpreadingIndex?.powerPercent* 100, {micrometer: true,}) : "-"
        }else if(val == "性价比指数"){
          this.rankObj.rankNum = costEffectiveModel?.videoPerformancePriceIndex?.powerValue || "-"
          this.rankObj.rankNo = costEffectiveModel?.videoPerformancePriceIndex?.powerRank || "-"
          this.rankObj.rankPercent = costEffectiveModel?.videoPerformancePriceIndex?.powerPercent ? this.fmt(costEffectiveModel?.videoPerformancePriceIndex?.powerPercent* 100, {micrometer: true,}) : "-"
        }else if(val == "商业力指数"){
          this.rankObj.rankNum = businessPowerModel?.videoBusinessIndexPercent?.powerValue || "-"
          this.rankObj.rankNo = businessPowerModel?.videoBusinessIndexPercent?.powerRank || "-"
          this.rankObj.rankPercent = businessPowerModel?.videoBusinessIndexPercent?.powerPercent ? this.fmt(businessPowerModel?.videoBusinessIndexPercent?.powerPercent* 100, {micrometer: true,}) : "-"
        }else if(val == "号召力指数"){
          this.rankObj.rankNum = appealPowerModel?.videoAppealIndex?.powerValue || "-"
          this.rankObj.rankNo = appealPowerModel?.videoAppealIndex?.powerRank || "-"
          this.rankObj.rankPercent = appealPowerModel?.videoAppealIndex?.powerPercent ? this.fmt(appealPowerModel?.videoAppealIndex?.powerPercent* 100, {micrometer: true,}) : "-"
        }else if(val == "发展力指数"){
          this.rankObj.rankNum = developPowerModel?.videoDevelopIndex?.powerValue || "-"
          this.rankObj.rankNo = developPowerModel?.videoDevelopIndex?.powerRank || "-"
          this.rankObj.rankPercent = developPowerModel?.videoDevelopIndex?.powerPercent ? this.fmt(developPowerModel?.videoDevelopIndex?.powerPercent* 100, {micrometer: true,}) : "-"
        }
      },
      immediate:true
    }
  },
  methods: {
    isAfterToday(targetTime) {
          // 将目标时间字符串转换为 Date 对象
          const targetDate = new Date(targetTime.replace(/-/g, '/'));
          // 获取当前日期并设置时间为 00:00:00
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // 比较目标时间是否在今天及之后
          let isFlag = targetDate >= today;
          return isFlag;
        },
    getDaysRemaining(dateStr) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将时间设置为当天的零点，避免时间影响

            const targetDate = new Date(dateStr);
            if (isNaN(targetDate.getTime())) {
                console.error('输入的日期格式不正确，请使用 "YYYY-MM-DD" 格式。');
                return null;
            }

            const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
            const diffTime = targetDate - today;
            return Math.round(diffTime / oneDay);
        },
    async getPjTableData() {
        if(!this.$route.query.mid){
          return
        }
        let params = {
            mid: this.$route.query.mid,
        };
        const res = await this.$axios.post(`/api.php?m=detail|api|gx&a=getCompetitive`, params)
        this.pjList = res.filter(x => {
              return this.isAfterToday(x.end_time)
            }) || [];
    },
    initGetKsProfile(val) {
      let darenInfo = val;
      // darenInfo.fansNumber = darenInfo.fansNumber
      // darenInfo.photoExpectClick=tools.setW(darenInfo.photoExpectClick)
      // darenInfo.videoBusinessReport.acceptOrderRate=tools.scale(darenInfo.videoBusinessReport.acceptOrderRate)
      // darenInfo.videoBusinessReport.completeOrderRate=tools.scale(darenInfo.videoBusinessReport.completeOrderRate)
      this.darenInfo = darenInfo;
    },
    getksIndex() {
      this.loading = true
      this.$api.getKuaishouData
        .getksIndex(`?userId=${this.darenInfo.userId}`)
        .then((res) => {
          this.ksIndex = res?.data?.data || {};
          console.log('this.ksIndex :>> ', this.ksIndex);
          this.videoStarIndex = res?.data.data?.starIndexPowerModel?.videoStarIndex || {}
          this.starPicRadar = {
            name: "",
            data: [
              {
                value: [],
                name: "达人指数",
                itemStyle: {
                  color: "#59B1FF",
                },
              },
              {
                value: [],
                name: "同类型中位数",
                itemStyle: {
                  color: "#ff5c00",
                },
              },
            ],
            radius:"60%",
            indicator: [
              {
                name: "传播力指数",
                max: 100,
                min: 0,
              },
              {
                name: "性价比指数",
                max: 100,
                min: 0,
              },
              {
                name: "商业力指数",
                max: 100,
                min: 0,
              },

              {
                name: "号召力指数",
                max: 100,
                min: 0,
              },
              {
                name: "发展力指数",
                max: 100,
                min: 0,
              },
            ],
            custom: {
              legend: {
                show: true,
                itemWidth: 8,
                itemHeight: 8,
                bottom: 0,
                left: 105,
                orient: "horizontal",
                textStyle: {
                  fontSize: 12,
                  color: "color",
                  borderRadius: 50,
                },
              },
            },
          };
          let {spreadingPowerModel, costEffectiveModel, businessPowerModel, appealPowerModel, developPowerModel} = this.ksIndex
          let data1=[spreadingPowerModel.videoSpreadingIndex.powerValue, costEffectiveModel.videoPerformancePriceIndex.powerValue, businessPowerModel.videoBusinessIndexPercent.powerValue, appealPowerModel.videoAppealIndex.powerValue, developPowerModel.videoDevelopIndex.powerValue]
          let data2=[spreadingPowerModel.videoSpreadingIndex.powerAvgValue,costEffectiveModel.videoPerformancePriceIndex.powerAvgValue, businessPowerModel.videoBusinessIndexPercent.powerAvgValue, appealPowerModel.videoAppealIndex.powerAvgValue, developPowerModel.videoDevelopIndex.powerAvgValue]
          let data = {}
          data.data1 = data1
          data.data2 = data2
          console.log('data1,data2 :>> ', data1,data2);
          this.starPicRadar.data = this.starPicRadar?.data?.map((x,i)=>{
            x.value = data[`data${i+1}`]
            return x
          })
          this.starPicRadar.indicator.forEach((x,i)=>{
            x.name = data.data1[i]? x.name+data.data1[i] : x.name
          })
          if(this.activeName == "传播力指数"){
            this.rankObj.rankNum = spreadingPowerModel?.videoSpreadingIndex?.powerValue || "-"
            this.rankObj.rankNo = spreadingPowerModel?.videoSpreadingIndex?.powerRank || "-"
            this.rankObj.rankPercent = this.fmt(spreadingPowerModel?.videoSpreadingIndex?.powerPercent* 100, {micrometer: true,}) || "-"
          }
        console.log('this.starPicRadar.data :>> ', this.starPicRadar.data);
        })
        .finally(()=>{
          this.loading = false
        })
    },
    rowClassName ({ row }) {
        if (row.is_black == 1) {
            return 'row-gray'
        }
        return null
    },
  },
  components: {
    Radar,
  },
  created() {
    //   达人基础数据
    this.initGetKsProfile(
      JSON.parse(window.sessionStorage.getItem("getKsProfile")).data.data
    );
    this.getksIndex();
    this.getPjTableData();
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.tips {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #4A5569;
    margin-bottom: 15px;
    i {
        color: #ff6f28;
        margin-right: 8px;
    }
}
.subTitle{
   /deep/ .el-tabs__item{
    height: 40px !important;
    line-height: 35px !important;
  }
  /deep/.el-tabs__nav-scroll{
    height: 40px !important;
  }
}
.flex_box {
  display: flex;
  flex-wrap: wrap;
}
.radar_box {
  margin-top: 16px;
  width: 365px;
  height: 235px;
}
.outlineContainer {
  width: 100%;
}
.outlineContainer .part1,
.part {
  padding: 30px 0px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 6px;
  background: #ffffff;
  margin-bottom: 15px;
}
.part {
  padding: 30px;
}
.drIndex {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #8c8c8c;
}
.drIndex .bignum {
  margin-right: 8px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #fe3666;
}
.drIndexRight{
  font-weight: 400;
  padding-left: 24px;
  font-size: 14px;
  line-height: 22px;
  color: #8c8c8c;
}
.drFirstRow{
  margin: 14px 0 24px 0;
}
.rankNum{
    margin-right: 8px;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #1f1f1f;
}
.indexSource{
  margin-bottom: 18px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000103;
}
.indexNum{
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #1f1f1f;
}

.indexBlock{
  width: calc(100% / 3);
  margin-bottom: 16px;
}
.part1 .title1,
.part .title1 {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #1f1f1f;
}
.part1 .subTitle {
  margin-left: 16px;
  font-size: 12px;
  color: #8c8c8c;
}
.part1 .left {
  float: left;
  width: 520px;
  margin-left: 30px;
}
.part1 .right {
  float: right;
  width: 250px;
  margin-right: 30px;
}
.part1 .left .center {
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
}

.part1 .left .center .centerItem {
  float: left;
  width: 33%;
  margin-top: 16px;
}

.part1 .left .center .centerItem span {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.part1 .left .center .centerItem p {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
/* .part1 .left .center .centerItem p i{
        display: inline-block;
        margin-left: 10px;
        padding: 0 8px;
        background: #f5f7f9;
        border-radius: 4px;
    } */
.part1 .left .tag span {
  float: left;
  height: 26px;
  margin-top: 10px;
  margin-right: 10px;
  padding: 0 8px;
  background: #f6f6f6;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  text-align: center;
  line-height: 26px;
}
.part1 .right .rightItem {
  width: 100%;
  margin-top: 26px;
}
.part1 .right .rightItem .title2 {
  position: relative;
  display: block;
  width: 100%;
  height: 16px;
  margin-bottom: 10px;
  padding-left: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #333333;
  box-sizing: border-box;
}
.part1 .right .rightItem .title2::before {
  position: absolute;
  left: 0;
  content: "";
  width: 12px;
  height: 16px;
  background: burlywood;
  background: url("../images/icon_7.png") no-repeat center;
}
.part1 .right .rightItem:nth-of-type(2) .title2::before {
  background-image: url("../images/icon_9.png");
}
.part1 .right .rightItem:nth-of-type(3) .title2::before {
  background-image: url("../images/icon_8.png");
}
.part1 .right .rightItem .tag {
  /* float: left; */
  display: inline-block;
  height: 26px;
  margin-bottom: 6px;
  padding: 0 8px;
  background: #f6f6f6;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
}
.top {
  width: 100%;
  height: 76px;
  margin-bottom: 120px;
  box-sizing: border-box;
  border-bottom: 1px solid #f0f0f0;
}
.top h5 {
  display: inline-block;
  font-size: 16px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #333333;
}
.top i {
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  font-family: OPPOSans;
  font-weight: 400;
  color: #999999;
}
.top .tab {
  float: right;
  margin-left: 16px;
  margin-top: 22px;
}
/* .part2{
        width: 100%;
        height: 220px;
        margin-top: 16px;
        background: #FFFFFF;
        border-radius: 6px;
    }
    .part2 .top{
        width: 804px;
        margin-left: 30px;
    }
    .part2 ul{
        width: 100%;
        height: 100px;
        margin: 0;
        padding: 30px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #F0F0F0;
        overflow: hidden;
    }
    .part2 ul li{
        float: left;
        width: 25%;
        height: 100%;
        border-right: 1px solid #F0F0F0;
        list-style:none;
        text-align: center;
        box-sizing: border-box;
    }
    .part2 ul li:nth-of-type(4){
        border: 0;
    }
    .part2 ul li span{
        font-size: 18px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }
    .part2 ul li p{
        position: relative;
        margin-top: 4px;
        margin-left: -14px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
        text-align: center;
    }
    .part2 ul li p i{
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        margin-left: 6px;
        width: 14px;
        height: 14px;
        cursor: pointer;
        background: url("../images/icon_6.png") no-repeat center;
    } */
</style>
<style lang="scss" scoped>
::v-deep .vxe-table .vxe-body--row.row-gray{
  background-color: #F2F3F5;
}
.fx-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>